import validate from "/app/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@types+node@22.15.21_@vue+compiler-sfc@3.5.27_cac@6.7._a8d9e379f563de760740bc7e10eff73c/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@types+node@22.15.21_@vue+compiler-sfc@3.5.27_cac@6.7._a8d9e379f563de760740bc7e10eff73c/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/app/middleware/auth.ts")
}